// extracted by mini-css-extract-plugin
export default {"tablehead":"ProducTable_tablehead__JMSMZ","custom-striped-table":"ProducTable_custom-striped-table__qKYF+"};